/**
 * Events Simple Component
 */
window.SLDS = window.SLDS || {};

window.SLDS["eventsSimple"] = function (apiUrl, limit = 3) {
  return {
    events: [],
    loading: true,
    error: false,

    init() {
      if (!apiUrl) {
        this.loading = false;
        this.error = true;
        return;
      }

      // Force HTTPS protocol
      if (typeof apiUrl === "string") {
        apiUrl = apiUrl.replace(/^http:\/\//i, "https://");

        // If the URL starts with double slashes (e.g., "//api.example.com"), prepends "https:"
        if (apiUrl.startsWith("//")) {
          apiUrl = `https:${apiUrl}`;
        }
      }

      fetch(apiUrl, {
        headers: { Accept: "application/json" },
      })
        .then((res) => {
          if (!res.ok) throw new Error(`HTTP ${res.status}`);
          return res.json();
        })
        .then((data) => {
          const items = Array.isArray(data)
            ? data
            : data.events || data.items || data.results || [];

          this.events = items.slice(0, limit).map((item, index) => {
            const rawDate =
              item.datetime_start || item.date_start || item.start_date || "";
            const occurrenceId =
              item.id ??
              item.event_id ??
              item.uid ??
              item.permalink ??
              item.url ??
              item.link ??
              "event";
            let dateObj = null;

            if (rawDate) {
              const match = rawDate.match(
                /^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2})$/,
              );
              dateObj = match
                ? new Date(
                    match[1],
                    match[2] - 1,
                    match[3],
                    match[4],
                    match[5],
                    match[6],
                  )
                : new Date(rawDate);
            }

            const validDate = dateObj && !isNaN(dateObj);

            let sponsors = [];
            if (Array.isArray(item.sponsors)) {
              sponsors = item.sponsors
                .map((s) =>
                  typeof s === "object"
                    ? s.group_name || s.name || s.title || ""
                    : s,
                )
                .filter(Boolean);
            }

            return {
              key: `${occurrenceId}-${rawDate || index}`,
              title:
                item.event_title || item.title || item.name || "Untitled Event",
              url: item.permalink || item.url || item.link || "#",
              location:
                item.location_name || item.building_name || item.location || "",
              isFeatured: Boolean(item.featured || item.is_featured),
              sponsors: sponsors.join(", "),
              dayOfWeek: validDate
                ? dateObj.toLocaleDateString("en-US", { weekday: "short" })
                : "",
              dayOfMonth: validDate
                ? dateObj.toLocaleDateString("en-US", { day: "2-digit" })
                : "",
              monthYear: validDate
                ? dateObj.toLocaleDateString("en-US", {
                    month: "short",
                    year: "numeric",
                  })
                : "",
              timeFormatted: validDate
                ? dateObj
                    .toLocaleTimeString("en-US", {
                      hour: "numeric",
                      minute: "2-digit",
                      hour12: true,
                    })
                    .toLowerCase()
                    .replace(/\s/g, "")
                : "",
            };
          });

          this.loading = false;
        })
        .catch((err) => {
          console.error("[SLDS Events] Fetch error:", err);
          this.error = true;
          this.loading = false;
        });
    },
  };
};
